import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    FormControlLabel,
    Checkbox,
    Grid,
} from "@mui/material";

const PermissionsDialog = ({
    open,
    onClose,
    onSubmit,
    permissionsList = [],
    selectedPermissions = {},
}) => {
    const [checkedMap, setCheckedMap] = useState({});
    const [originalMap, setOriginalMap] = useState({});

    useEffect(() => {
        if (!permissionsList.length) return;

        let parsed = selectedPermissions;

        if (typeof selectedPermissions === "string") {
            try {
                parsed = JSON.parse(selectedPermissions);
            } catch (e) {
                parsed = {};
            }
        }

        const filtered = {};

        permissionsList.forEach((perm) => {
            if (perm.isEnabled) {
                filtered[perm.id] = parsed?.[perm.id] ?? false;
            }
        });

        setCheckedMap(filtered);
        setOriginalMap(filtered);
    }, [selectedPermissions, permissionsList]);


    const handleToggle = (permission) => {
        if (!permission.isEnabled) return;

        setCheckedMap((prev) => ({
            ...prev,
            [permission.id]: !prev[permission.id],
        }));
    };

    const handleSubmit = () => {
        const changedPermissions = {};

        permissionsList.forEach((perm) => {
            if (!perm.isEnabled) return;

            const id = perm.id;

            const originalValue = !!originalMap[id];
            const currentValue = !!checkedMap[id];

            if (originalValue !== currentValue) {
                changedPermissions[id] = currentValue;
            }
        });

        onSubmit(changedPermissions);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 2,
                },
            }}
        >
            <DialogContent>
                <Box textAlign="center" mb={2}>
                    <Typography variant="h6" fontWeight="bold">
                        Assign Permissions
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Select permissions for this user
                    </Typography>
                </Box>

                <Grid container spacing={1}>
                    {permissionsList.map((permission) => {
                        const isChecked = !!checkedMap[permission.id];
                        const isDisabled = !permission.isEnabled || permission?.id != 1;

                        return (
                            <Grid item xs={12} sm={6} key={permission.id}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isChecked}
                                            onChange={() => handleToggle(permission)}
                                            disabled={isDisabled}
                                        />
                                    }
                                    label={permission.name}
                                    sx={{
                                        opacity: isDisabled ? 0.5 : 1,
                                    }}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="error"
                    size="small"
                    sx={{ color: "black", fontWeight: "bold" }}
                >
                    Cancel
                </Button>

                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    size="small"
                    sx={{ color: "beige", fontWeight: "bold" }}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PermissionsDialog;